import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo.js";

const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <Link to="/" className="brand">
        <Logo size={28} />
        <span className="brand-text">
          MECK<span className="brand-dim">INTERACTIVE</span>
        </span>
      </Link>
      <div className="footer-links">
        <a href="mailto:app@meck-int.com">app@meck-int.com</a>
        <Link to="/privacy">Privacy Policy</Link>
      </div>
      <span className="footer-copy">© {new Date().getFullYear()} Meck Interactive</span>
    </div>
  </footer>
);

export default Footer;
